export default "__VITE_ASSET__Bx$0bZwy__"